import { memo } from "react";

function Select(props) {
  return (
    <div className="form-floating font-weight-bold my-1">
      <select
        className="form-select"
        name={props.name}
        onChange={(e) => props.Change(e.target.value)}
        value={props.value}
      >
        <option value="">--Seçiniz--</option>

        {props.liste &&
          props.liste.map((deger) => (
            <option key={deger.id} value={deger.name}>
              {deger.name}
            </option>
          ))}
      </select>

      <label className="ms-2 fw-bolder">
        <strong>{props.mesaj}</strong>
      </label>
    </div>
  );
}

export default memo(Select);
